import { BRAND_NAME } from "@chef/constants";

import { Level } from "./CancelSubscriptionPage";
import { intl } from "./CancelSubscriptionPage.Intl";

interface SURVEY_STEP {
  title: string;
  level?: Level;
  options: {
    text: string;
    next?: SURVEY_STEP;
  }[];
}

const WHERE_WILL_YOU_BUY_FOOD_NOW_STEP = {
  title: intl.WHERE_WILL_YOU_BUY_FOOD_IN_THE_FUTURE,
  level: "sub_freeze_followup_answer",
  options: [
    {
      text: intl.ANOTHER_ONLINE_GROCERY_STORE,
    },
    {
      text: intl.ANOTHER_ONLINE_MEALBOX_SERVICE,
    },
    {
      text: intl.PHYSICAL_STORE,
    },
  ],
};

const WHY_DOES_NOT_THE_CONCEPT_SUIT_YOU_STEP = {
  title: intl.WHY_DOES_NOT_THE_CONCEPT_SUIT_YOU,
  level: "sub_freeze_followup_answer",
  options: [
    {
      text: intl.THE_ORDER_DEADLINE_IS_TOO_EARLY,
    },
    {
      text: intl.THE_NUMBER_PORTIONS_AVAILABLE_DOES_NOT_SUIT,
    },
  ],
};

const WHAT_DID_YOU_DISLIKE_ABOUT_THE_MENU_STEP = {
  title: intl.WHAT_ABOUT_THE_MENUS_ARE_YOU_DISSATISFIED_WITH,
  level: "sub_freeze_followup_answer",
  options: [
    {
      text: intl.VARIETY_OF_INGREDIENTS_CONTENTS_IN_THE_DISHES,
    },
    {
      text: intl.THE_SELECTED_COMBINATION_OF_DISHES,
    },
    {
      text: intl.SELECTION_OF_DISH_TYPES,
    },
    {
      text: intl.THE_MENU_SUGGESTIONS_DO_NOT_MATCH_MY_SELECTED_PREFERENCES,
    },
    {
      text: intl.I_HAVE_TOO_MANY_INGREDIENTS_AT_HOME,
    },
    {
      text: intl.UNNECESSARY_INGREDIENTS_I_ALREADY_HAVE_ARE_DELIVERED,
    },
  ],
};

const WHAT_DID_YOU_DISLIKE_ABOUT_THE_INGREDIENTS_STEP = {
  title: intl.WHAT_ABOUT_THE_INGREDIENTS_ARE_YOU_DISSATISFIED_WITH,
  level: "sub_freeze_followup_answer",
  options: [
    {
      text: intl.TOO_MUCH_PACKAGING,
    },
    {
      text: intl.EXPIRATION_DATE_AND_QUALITY_OF_INGREDIENTS,
    },
    {
      text: intl.I_WANT_ORGANIC_INGREDIENTS,
    },
    {
      text: intl.BETTER_ANIMAL_WELFARE,
    },
  ],
};

const WHAT_DID_YOU_DISLIKE_ABOUT_THE_THE_CARTON_BOX_STEP = {
  title: intl.WHY_DID_YOU_DISLIKE_THE_CARTON_BOX,
  level: "sub_freeze_followup_answer",
  options: [
    {
      text: intl.IT_IS_TOO_BIG_OR_DIFFICULT_TO_HANDLE,
    },
    {
      text: intl.THE_WAY_THE_INGREDIENTS_ARE_ORGANIZED,
    },
    {
      text: intl.IT_LACKED_COOLING_ELEMENTS_IN_THE_BOX,
    },
    {
      text: intl.I_WANT_THE_SERVICE_TO_RETURN_THE_BOX,
    },
  ],
};

export const steps = {
  START_SURVEY_STEP: {
    title: intl.WHY_DO_YOU_WANT_TO_PAUSE,
    level: "main_freeze_reason",
    options: [
      {
        text: intl.I_JUST_WANT_TO_TAKE_A_BREAK,
        next: {
          title: intl.I_JUST_WANT_TO_TAKE_A_BREAK,
          level: "sub_freeze_reason",
          options: [
            {
              text: intl.I_JUST_WANT_TO_TAKE_A_BREAK,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.I_HAVE_A_LIMITED_BUDGET_AT_THE_MOMENT,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.I_AM_GOING_ON_VACATION,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.I_HAVE_A_BUSY_PERIOD_AHEAD,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
          ],
        },
      },
      {
        text:
          BRAND_NAME === "RN"
            ? intl.PRICE_IS_TOO_HIGH
            : intl.THE_MEALBOX_IS_TOO_EXPENSIVE,
        next: {
          title:
            BRAND_NAME === "RN"
              ? intl.PRICE_IS_TOO_HIGH
              : intl.THE_MEALBOX_IS_TOO_EXPENSIVE,
          level: "sub_freeze_reason",
          options: [
            {
              text: intl.THE_MEALBOX_IS_TOO_EXPENSIVE,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.TOO_MANY_DISHES_COST_EXTRA,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
          ],
        },
      },
      {
        text: intl.THE_MEALBOX_DOES_NOT_SUIT_US,
        next: {
          title: intl.THE_MEALBOX_DOES_NOT_SUIT_US,
          level: "sub_freeze_reason",
          options: [
            {
              text: intl.THE_CONCEPT_DOES_NOT_SUIT_US,
              next: WHY_DOES_NOT_THE_CONCEPT_SUIT_YOU_STEP,
            },
            {
              text: intl.WE_WANT_TO_COOK_OUR_OWN_FOOD,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.TOO_LITTLE_FOOD_FOR_OUR_FAMILY,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.TOO_MUCH_FOOD_FOR_OUR_FAMILY,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.WE_DO_NOT_HAVE_ENOUGH_TIME_IN_OUR_DAILY_LIFE,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
          ],
        },
      },
      {
        text: intl.INGREDIENT_OR_MENU,
        next: {
          title: intl.INGREDIENT_OR_MENU,
          level: "sub_freeze_reason",
          options: [
            {
              text: intl.NOT_SATISFIED_WITH_THE_MENUS,
              next: WHAT_DID_YOU_DISLIKE_ABOUT_THE_MENU_STEP,
            },
            {
              text: intl.QUALITY_OF_THE_INGREDIENTS,
              next: WHAT_DID_YOU_DISLIKE_ABOUT_THE_INGREDIENTS_STEP,
            },
            {
              text: intl.NEITHER_WE_NOR_THE_KIDS_LIKE_THE_FOOD,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.WE_HAVE_ALLERGIES_IN_THE_FAMILY,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.TOO_ADVANCED_OR_TAKES_TOO_LONG,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.MISSING_INGREDIENTS,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
          ],
        },
      },
      {
        text: intl.TRANSPORT_OR_DELIVERY,
        next: {
          title: intl.TRANSPORT_OR_DELIVERY,
          level: "sub_freeze_reason",
          options: [
            {
              text: intl.DID_NOT_LIKE_THE_BOX_ITSELF,
              next: WHAT_DID_YOU_DISLIKE_ABOUT_THE_THE_CARTON_BOX_STEP,
            },
            {
              text: intl.DID_NOT_DELIVER_AS_AGREED,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.DELIVERY_TIMES_DID_NOT_SUIT_ME,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.COULD_NOT_DELIVER_TO_MY_ADDRESS,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
            {
              text: intl.DELIVERY_FEE,
              next: WHERE_WILL_YOU_BUY_FOOD_NOW_STEP,
            },
          ],
        },
      },
    ],
  } as SURVEY_STEP,
};
